<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <deuda-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import DeudaCrud from "./DeudaCrud";
    export default {
        name: "Deuda",
        components: {DeudaCrud}
    }
</script>

<style scoped>

</style>

